import { MessageDispatchForm } from "./parts/message-dispatch-form";
import { MessageDispatchFormContextProvider } from "./parts/message-dispatch-form/message-dispatch-form.context";
import { BaseScreen } from "../../components/base-screen";

export const MessageDispatchEditScreen = () => {
	return (
		<BaseScreen>
			<MessageDispatchFormContextProvider>
				<MessageDispatchForm />
			</MessageDispatchFormContextProvider>
		</BaseScreen>
	);
};
